import type { components } from './types.gen';

/** RFC 7807 error model from the backend */
export type ApiError = components['schemas']['ErrorModel'];
export type ApiErrorDetail = components['schemas']['ErrorDetail'];

/** Type guard — checks shape, not instanceof */
export function isApiError(err: unknown): err is ApiError {
  return (
    typeof err === 'object' &&
    err !== null &&
    'type' in err &&
    typeof (err as Record<string, unknown>).type === 'string'
  );
}

/** Extract human-readable message from any error shape */
export function getErrorMessage(err: unknown): string {
  if (isApiError(err)) {
    return err.detail || err.title || 'Something went wrong';
  }
  if (err instanceof Error) {
    return err.message;
  }
  return 'An unexpected error occurred';
}

/** Check if error is a specific HTTP status */
export function isHttpStatus(err: unknown, status: number): boolean {
  return isApiError(err) && err.status === status;
}
